import { FC } from "react";
import { DropDown } from "../../../common/components/DropDown";
import { Option } from "../../../common/interface/interface";
import { SelectChangeEvent } from "@mui/material";

interface Props {
  areaTags: string;
  options: Option[];
  onChange?: (e: SelectChangeEvent) => void;
}

export const AreaTags: FC<Props> = ({ areaTags, options, onChange }) => {
  return (
    <DropDown
      name="Area"
      value={areaTags}
      options={options}
      onChange={onChange}
    />
  );
};
